import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const Footer: React.FC = () => {
  const { t } = useTranslation("common");
  return (
    <footer className="bg-[#0a0a0a] border-t border-gray-800 py-6 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center text-gray-400">
        <div className="flex flex-wrap justify-center md:justify-start gap-x-4 gap-y-2 mb-4 md:mb-0">
          <Link to="/guides" className="hover:text-white transition-colors">
            {t("footer.guides")}
          </Link>
          <Link to="/about" className="hover:text-white transition-colors">
            {t("footer.about")}
          </Link>
          <Link to="/contact" className="hover:text-white transition-colors">
            {t("footer.contact")}
          </Link>
          <Link to="/terms" className="hover:text-white transition-colors">
            {t("footer.terms")}
          </Link>
          <Link to="/privacy" className="hover:text-white transition-colors">
            {t("footer.privacy")}
          </Link>
          <Link to="/security" className="hover:text-white transition-colors">
            {t("footer.security")}
          </Link>
          <Link to="/support" className="hover:text-white transition-colors">
            {t("footer.support")}
          </Link>
        </div>
        <p className="text-sm">
          {t("footer.rights", { year: new Date().getFullYear() })}
        </p>
      </div>
    </footer>
  );
};
